<div class="gallery gallery_columns-{{ columns }}">
  @for (galleryItem of galleryItems; track $index) {
    <app-gallery-item [galleryItem]="galleryItem" />
  }
</div>
